import { mapReverseCupModeFormat } from "./FsReverseCupModeFormat";
import { calculateFinalPositions } from "model/Positions";
import { ReverseCupModeSet } from "model/Match/Set/CupMode/ReverseCupModeSet";
import { nonUndefined } from "Utility";
import { mapReverseCupModeTracks } from "./FsReverseCupModeTrack";
import { MatchTeams } from "model/Match/MatchTeams";
import { applyScoreOverrides, Scores } from "model/Scores";
import { FsReverseCupModeSet } from "db/model/match/Set/CupMode/Reverse/FsReverseCupModeSet";
import { mapMatchSetBase } from "../../FsMatchSet";
import {
  getForfeitedRosterIds,
  getNumPlayingRosters,
} from "model/Roster/Roster";
import {
  getPlayTill,
  PlayTill,
  playTillReached,
} from "model/Match/Set/CupMode/Format/CupModeFormat";

// todo - lots of dupe code with Forward version, e.g. isComplete logic
export const mapReverseCupModeSet = (
  fsModel: FsReverseCupModeSet,
  teams: MatchTeams
): ReverseCupModeSet | undefined => {
  if (!fsModel.format) {
    return undefined;
  }

  const format = mapReverseCupModeFormat(fsModel.format);
  if (!format) {
    return undefined;
  }

  const scores: Scores = {};
  const playTill = getPlayTill(format);
  const tracks = mapReverseCupModeTracks(
    nonUndefined(fsModel.tracks ?? []),
    teams.rosters,
    teams.scope,
    scores,
    format
  );

  const numPlayingTeams = getNumPlayingRosters(teams.rosters, true);
  getForfeitedRosterIds(teams.rosters).forEach(
    (rosterId) => (scores[rosterId] = numPlayingTeams * -1)
  );

  applyScoreOverrides(scores, fsModel.scoreOverrides);

  const isComplete =
    fsModel.overrideComplete || calculateIsComplete(scores, playTill);

  if (isComplete) {
    tracks.forEach((t) => t.isComplete);
  }

  const finalPositions = calculateFinalPositions(
    isComplete,
    scores,
    compareScores
  );

  return {
    ...mapMatchSetBase(fsModel, isComplete, finalPositions, scores),
    format,
    tracks,
    type: "ReverseCupMode",
  };
};

const calculateIsComplete = (scores: Scores, playTill: PlayTill) => {
  const numRosters = Object.values(scores).length;
  if (numRosters === 0) {
    return false;
  }

  const numLeft = Object.values(scores).filter((s) => s >= 0).length;
  const numFinished = Object.values(scores).filter((s) => s < 0).length;
  return playTillReached(playTill, numLeft, numFinished);
};

// todo - Apply tiebreakers here
const compareScores = (scores: Scores, a: string, b: string) => {
  return scores[b] - scores[a];
};
